// import React, { useState, useEffect, useMemo } from "react";
// import Modal from "react-bootstrap/Modal";
// import "./QuizPreviewModal.scss";

// const TYPE_TO_SECTION = {
//   mcq: "mcq",
//   fill_in_the_blank: "fib",
//   fib: "fib",
//   fill_ups: "fib",
//   short_answer: "short",
//   short: "short",
// };

// const getQuestionText = (q) => q?.question_text ?? q?.question ?? "";
// const getQuestionKey = (q, idx) => q?.question_id ?? q?.id ?? idx;

// const groupQuestionsByType = (questions) => {
//   const grouped = { mcq: [], fib: [], short: [], other: [] };
//   (Array.isArray(questions) ? questions : []).forEach((q) => {
//     grouped[TYPE_TO_SECTION[q?.question_type] || "other"].push(q);
//   });
//   return grouped;
// };

// const getMarksLabel = (list, fallbackMarks) => {
//   const marks = [
//     ...new Set(list.map((q) => q?.max_marks).filter((m) => m !== null && m !== undefined)),
//   ];
//   if (marks.length > 1) return "(Marks vary)";
//   const m = marks.length === 1 ? marks[0] : fallbackMarks;
//   return `(${m} ${Number(m) === 1 ? "Mark" : "Marks"} each)`;
// };

// const QuizPreviewModal = ({ show, onHide, data }) => {
//   const [activeSetNumber, setActiveSetNumber] = useState(null);

//   // Sets sorted by set_number, each with a guaranteed numeric `number`.
//   const sets = useMemo(() => {
//     const raw = Array.isArray(data?.sets) ? data.sets : [];
//     return raw
//       .map((s, i) => ({ ...s, number: s?.set_number ?? i + 1 }))
//       .sort((a, b) => a.number - b.number);
//   }, [data]);

//   useEffect(() => {
//     setActiveSetNumber(null);
//   }, [show, data?.assignment_id]);

//   if (!data) return null;

//   const hasSets = sets.length > 0;
//   // Falls back to the first set until/unless another one is chosen.
//   const activeSet = hasSets ? sets.find((s) => s.number === activeSetNumber) || sets[0] : null;

//   // Sets take priority; assignments created before sets existed still use
//   // `assignment_data`.
//   const grouped = activeSet
//     ? groupQuestionsByType(activeSet.questions)
//     : {
//         mcq: data.assignment_data?.mcq || [],
//         fib: data.assignment_data?.fill_in_the_blank || [],
//         short: data.assignment_data?.short_answer || [],
//         other: [],
//       };

//   const mcqList = grouped.mcq;
//   const fibList = grouped.fib;
//   const shortList = grouped.short;
//   const otherList = grouped.other;

//   const shownCount = mcqList.length + fibList.length + shortList.length + otherList.length;
//   const totalQuestions = activeSet ? shownCount : data?.total_questions || 0;

//   const chapterLabel = Array.isArray(data.chapter) ? data.chapter.join(", ") : data.chapter;

//   return (
//     <Modal show={show} onHide={onHide} size="lg" centered className="quiz-preview-modal" scrollable>
//       <Modal.Header closeButton className="border-0 pb-2">
//         <div>
//            <h5 className="fw-bold m-0 text-dark">Assessment Preview</h5>
//            <p className="text-muted fz12 mb-0">Reviewing generated paper structure</p>
//         </div>
//       </Modal.Header>

//       <Modal.Body className="p-0 bg-light">

//         {/* TOP BAR: Summary of Selection */}
//         <div className="summary-strip">
//            <div className="strip-item">
//               <span className="lbl">Subject:</span>
//               <span className="val">{data?.subject}</span>
//            </div>
//            <div className="strip-item">
//               <span className="lbl">Topic:</span>
//               <span className="val">{chapterLabel}</span>
//            </div>
//               <div className="strip-item">
//               <span className="lbl">Set ID:</span>
//               <span className="val">{activeSet?.set_id}</span>
//            </div>
//            <div className="strip-item">
//               <span className="lbl">Total Qs:</span>
//               <span className="val fw-bold text-primary">
//                 {totalQuestions}
//               </span>
//            </div>
//            <div className="strip-item ms-auto">
//               <span className="badge bg-warning text-dark">Draft Mode</span>
//            </div>
//         </div>

//         {/* SET SWITCHER: only when the assignment has sets (Set 1 by default) */}
//         {hasSets && (
//           <div
//             className="set-switcher d-flex align-items-center flex-wrap gap-2 px-4 pt-3"
//             role="group"
//             aria-label="Select question set"
//           >
//             <span className="text-muted fz12 fw-bold me-1">Sets:</span>
//             {sets.map((s) => {
//               const isActive = s.number === activeSet?.number;
//               return (
//                 <button
//                   key={s.set_id ?? s.number}
//                   type="button"
//                   className={`btn btn-sm fw-bold ${isActive ? "btn-primary" : "btn-outline-primary"}`}
//                   aria-pressed={isActive}
//                   onClick={() => setActiveSetNumber(s.number)}
//                 >
//                   Set {s.number}
//                 </button>
//               );
//             })}
//           </div>
//         )}

//         {/* MAIN QUESTION LIST CONTAINER */}
//         <div className="paper-container p-4">

//           {/* 1. MCQ SECTION */}
//           {mcqList.length > 0 && (
//             <div className="question-section mb-4">
//               <div className="section-header">
//                 <h6 className="section-title">Section A: Multiple Choice Questions</h6>
//                 <span className="marks-info">{getMarksLabel(mcqList, 1)}</span>
//               </div>

//               {mcqList.map((q, qIdx) => (
//                 <div key={getQuestionKey(q, qIdx)} className="question-card">
//                   <div className="q-head">
//                     {/* <span className="q-num">Q{questionCounter++}.</span> */}
//                     <p className="q-text">{getQuestionText(q)}</p>
//                   </div>
//                   <div className="options-grid">
//                     {(q.options || []).map((opt, idx) => (
//                       <div key={idx} className="option-pill">
//                         <span className="opt-letter">{String.fromCharCode(65 + idx)}</span>
//                         {opt}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* 2. FIB SECTION */}
//           {fibList.length > 0 && (
//             <div className="question-section mb-4">
//               <div className="section-header">
//                 <h6 className="section-title">Section B: Fill in the Blanks</h6>
//                 <span className="marks-info">{getMarksLabel(fibList, 1)}</span>
//               </div>

//               {fibList.map((q, qIdx) => (
//                 <div key={getQuestionKey(q, qIdx)} className="question-card">
//                   <div className="q-head">
//                     {/* <span className="q-num">Q{questionCounter++}.</span> */}
//                     <p className="q-text">{getQuestionText(q)}</p>
//                   </div>
//                   <div className="answer-placeholder">
//                     <span>Answer: __________________________</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* 3. SHORT Q SECTION */}
//           {shortList.length > 0 && (
//             <div className="question-section mb-4">
//               <div className="section-header">
//                 <h6 className="section-title">Section C: Short Answer Questions</h6>
//                 <span className="marks-info">{getMarksLabel(shortList, 2)}</span>
//               </div>

//               {shortList.map((q, qIdx) => (
//                 <div key={getQuestionKey(q, qIdx)} className="question-card">
//                    <div className="q-head">
//                     {/* <span className="q-num">Q{questionCounter++}.</span> */}
//                     <p className="q-text">{getQuestionText(q)}</p>
//                   </div>
//                   <div className="writing-space short">
//                     <div className="line"></div>
//                     <div className="line"></div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* 4. OTHER (question types not mapped above, so nothing is hidden) */}
//           {otherList.length > 0 && (
//             <div className="question-section mb-4">
//               <div className="section-header">
//                 <h6 className="section-title">Section D: Other Questions</h6>
//                 <span className="marks-info">{getMarksLabel(otherList, 1)}</span>
//               </div>

//               {otherList.map((q, qIdx) => (
//                 <div key={getQuestionKey(q, qIdx)} className="question-card">
//                   <div className="q-head">
//                     <p className="q-text">{getQuestionText(q)}</p>
//                   </div>
//                   {Array.isArray(q.options) && q.options.length > 0 && (
//                     <div className="options-grid">
//                       {q.options.map((opt, idx) => (
//                         <div key={idx} className="option-pill">
//                           <span className="opt-letter">{String.fromCharCode(65 + idx)}</span>
//                           {opt}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* EMPTY STATE: no questions for this assignment / selected set */}
//           {shownCount === 0 && (
//              <div className="text-center py-5 text-muted">
//                 <p>{hasSets ? `No questions in Set ${activeSet?.number}.` : "No questions selected for this quiz."}</p>
//              </div>
//           )}

//         </div>
//       </Modal.Body>
//       <Modal.Footer className="border-0 pt-2 bg-white">
//         <button className="btn btn-secondary w-100 fw-bold" onClick={onHide}>Close Preview</button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default QuizPreviewModal;

import React, { useState, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { Trash2 } from "lucide-react";
import "./QuizPreviewModal.scss";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import Loader from "../../../../utils/loader/loader";
import DeleteConfirmModal from "../../../common/deleteConfirmModal/deleteConfirmModal";
import { deleteQuestionFromAssignment } from "../../../../Redux/Teacher_Panel/Teacher_Resource/resource.action";

const TYPE_TO_SECTION = {
  mcq: "mcq",
  fill_in_the_blank: "fib",
  fib: "fib",
  fill_ups: "fib",
  short_answer: "short",
  short: "short",
};

const getQuestionText = (q) => q?.question_text ?? q?.question ?? "";
const getQuestionId = (q) => q?.question_id ?? q?.id;
const getQuestionKey = (q, idx) => getQuestionId(q) ?? idx;

/* Deleted questions are tracked per set, so the same question in another set is untouched */
const deletedKey = (setId, questionId) => `${setId ?? "none"}:${questionId}`;

const groupQuestionsByType = (questions) => {
  const grouped = { mcq: [], fib: [], short: [], other: [] };
  (Array.isArray(questions) ? questions : []).forEach((q) => {
    grouped[TYPE_TO_SECTION[q?.question_type] || "other"].push(q);
  });
  return grouped;
};

// "(1 Mark each)" taken from the questions themselves when they agree,
// otherwise the section's usual default.
const getMarksLabel = (list, fallbackMarks) => {
  const marks = [
    ...new Set(
      list
        .map((q) => q?.max_marks)
        .filter((m) => m !== null && m !== undefined),
    ),
  ];
  if (marks.length > 1) return "(Marks vary)";
  const m = marks.length === 1 ? marks[0] : fallbackMarks;
  return `(${m} ${Number(m) === 1 ? "Mark" : "Marks"} each)`;
};

/**
 * Props:
 *  show, onHide, data
 *  canDelete  (default true) hides the delete icons when false
 *  onDeleted  optional callback after a successful delete, e.g. to refetch the assignment
 */
const QuizPreviewModal = ({
  show,
  onHide,
  data,
  canDelete = true,
  onDeleted,
}) => {
  const dispatch = useDispatch();

  const [activeSetNumber, setActiveSetNumber] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  /* { questionId, setId } of the question waiting for delete confirmation */
  const [pendingDelete, setPendingDelete] = useState(null);
  /* keys of questions already deleted, so the preview updates without a refetch */
  const [deletedKeys, setDeletedKeys] = useState(() => new Set());

  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  // Sets sorted by set_number, each with a guaranteed numeric `number`.
  const sets = useMemo(() => {
    // Some endpoints name the list `sets`, the history endpoint `set_data`.
    const raw = Array.isArray(data?.sets)
      ? data.sets
      : Array.isArray(data?.set_data)
        ? data.set_data
        : [];
    return raw
      .map((s, i) => ({ ...s, number: s?.set_number ?? i + 1 }))
      .sort((a, b) => a.number - b.number);
  }, [data]);

  // Always open on the first set: when the modal is (re)opened or a different
  // assignment is previewed.
  useEffect(() => {
    setActiveSetNumber(null);
  }, [show, data?.assignment_id]);

  // A different assignment starts with a clean slate
  useEffect(() => {
    setDeletedKeys(new Set());
  }, [data?.assignment_id]);

  if (!data) return null;

  const hasSets = sets.length > 0;
  // Falls back to the first set until/unless another one is chosen.
  const activeSet = hasSets
    ? sets.find((s) => s.number === activeSetNumber) || sets[0]
    : null;
  const activeSetId = activeSet?.set_id;

  const notDeleted = (q) =>
    !deletedKeys.has(deletedKey(activeSetId, getQuestionId(q)));

  // Sets take priority; assignments created before sets existed still use
  // `assignment_data`.
  const grouped = activeSet
    ? groupQuestionsByType(activeSet.questions)
    : {
        mcq: data.assignment_data?.mcq || [],
        fib: data.assignment_data?.fill_in_the_blank || [],
        short: data.assignment_data?.short_answer || [],
        other: [],
      };

  const mcqList = grouped.mcq.filter(notDeleted);
  const fibList = grouped.fib.filter(notDeleted);
  const shortList = grouped.short.filter(notDeleted);
  const otherList = grouped.other.filter(notDeleted);

  const shownCount =
    mcqList.length + fibList.length + shortList.length + otherList.length;
  // `total_questions` is the per-set size; when viewing a set count what is shown.
  const totalQuestions = activeSet
    ? shownCount
    : Math.max((data?.total_questions || 0) - deletedKeys.size, 0);

  const chapterLabel = Array.isArray(data.chapter)
    ? data.chapter.join(", ")
    : data.chapter;

  /* ----- delete flow ----- */

  const openDeleteConfirm = (q) => {
    setPendingDelete({ questionId: getQuestionId(q), setId: activeSetId });
    setShowConfirmModal(true);
  };

  const closeDeleteConfirm = () => {
    if (loading) return;
    setShowConfirmModal(false);
    setPendingDelete(null);
  };

  const showToast = (message, type) =>
    setToastState({ show: true, message, type });

  const handleConfirmDelete = async () => {
    if (!pendingDelete) return;
    const { questionId, setId } = pendingDelete;

    const payload = {
      assignment_id: data.assignment_id,
      ...(setId !== undefined && setId !== null ? { set_id: setId } : {}),
      question_id: questionId,
    };

    setLoading(true);
    try {
      const result = await dispatch(deleteQuestionFromAssignment(payload));
      if (result?.success) {
        setDeletedKeys((prev) =>
          new Set(prev).add(deletedKey(setId, questionId)),
        );
        showToast("Question deleted successfully", "success");
        onDeleted?.(payload);
      } else {
        showToast(result?.message || "Failed to delete the question", "error");
      }
    } catch (error) {
      showToast(
        error?.message || "Something went wrong while deleting",
        "error",
      );
    } finally {
      setLoading(false);
      setShowConfirmModal(false);
      setPendingDelete(null);
    }
  };

  /* Question text with the delete icon on the right */
  const renderQuestionHead = (q) => (
    <div className="q-head">
      <p className="q-text">{getQuestionText(q)}</p>
      {canDelete && (
        <button
          type="button"
          className="q-delete-btn"
          aria-label="Delete question"
          title="Delete question"
          disabled={loading}
          onClick={() => openDeleteConfirm(q)}
        >
          <Trash2 size={16} />
        </button>
      )}
    </div>
  );

  const renderOptions = (q) =>
    Array.isArray(q.options) && q.options.length > 0 ? (
      <div className="options-grid">
        {q.options.map((opt, idx) => (
          <div key={idx} className="option-pill">
            <span className="opt-letter">{String.fromCharCode(65 + idx)}</span>
            {opt}
          </div>
        ))}
      </div>
    ) : null;

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        className="quiz-preview-modal"
        scrollable
      >
        <Modal.Header closeButton className="border-0 pb-2">
          <div>
            <h5 className="fw-bold m-0 text-dark">Assessment Preview</h5>
            <p className="text-muted fz12 mb-0">
              Reviewing generated paper structure
            </p>
          </div>
        </Modal.Header>

        <Modal.Body className="p-0 bg-light">
          {/* TOP BAR: Summary of Selection */}
          <div className="summary-strip">
            <div className="strip-item">
              <span className="lbl">Subject:</span>
              <span className="val">{data.subject}</span>
            </div>
            <div className="strip-item">
              <span className="lbl">Topic:</span>
              <span className="val">{chapterLabel}</span>
            </div>
            <div className="strip-item">
              <span className="lbl">Total Qs:</span>
              <span className="val fw-bold text-primary">{totalQuestions}</span>
            </div>
            <div className="strip-item ms-auto">
              <span className="badge bg-warning text-dark">Draft Mode</span>
            </div>
          </div>

          {/* SET SWITCHER: only when the assignment has sets (Set 1 by default) */}
          {hasSets && (
            <div
              className="set-switcher d-flex align-items-center flex-wrap gap-2 px-4 pt-3"
              role="group"
              aria-label="Select question set"
            >
              <span className="text-muted fz12 fw-bold me-1">Sets:</span>
              {sets.map((s) => {
                const isActive = s.number === activeSet?.number;
                return (
                  <button
                    key={s.set_id ?? s.number}
                    type="button"
                    className={`btn btn-sm fw-bold ${isActive ? "btn-primary" : "btn-outline-primary"}`}
                    aria-pressed={isActive}
                    onClick={() => setActiveSetNumber(s.number)}
                  >
                    Set {s.number}
                  </button>
                );
              })}
            </div>
          )}

          {/* MAIN QUESTION LIST CONTAINER */}
          <div className="paper-container p-4">
            {/* 1. MCQ SECTION */}
            {mcqList.length > 0 && (
              <div className="question-section mb-4">
                <div className="section-header">
                  <h6 className="section-title">
                    Section A: Multiple Choice Questions
                  </h6>
                  <span className="marks-info">
                    {getMarksLabel(mcqList, 1)}
                  </span>
                </div>

                {mcqList.map((q, qIdx) => (
                  <div key={getQuestionKey(q, qIdx)} className="question-card">
                    {renderQuestionHead(q)}
                    {renderOptions(q)}
                  </div>
                ))}
              </div>
            )}

            {/* 2. FIB SECTION */}
            {fibList.length > 0 && (
              <div className="question-section mb-4">
                <div className="section-header">
                  <h6 className="section-title">
                    Section B: Fill in the Blanks
                  </h6>
                  <span className="marks-info">
                    {getMarksLabel(fibList, 1)}
                  </span>
                </div>

                {fibList.map((q, qIdx) => (
                  <div key={getQuestionKey(q, qIdx)} className="question-card">
                    {renderQuestionHead(q)}
                    <div className="answer-placeholder">
                      <span>Answer: __________________________</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* 3. SHORT Q SECTION */}
            {shortList.length > 0 && (
              <div className="question-section mb-4">
                <div className="section-header">
                  <h6 className="section-title">
                    Section C: Short Answer Questions
                  </h6>
                  <span className="marks-info">
                    {getMarksLabel(shortList, 2)}
                  </span>
                </div>

                {shortList.map((q, qIdx) => (
                  <div key={getQuestionKey(q, qIdx)} className="question-card">
                    {renderQuestionHead(q)}
                    <div className="writing-space short">
                      <div className="line"></div>
                      <div className="line"></div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* 4. OTHER (question types not mapped above, so nothing is hidden) */}
            {otherList.length > 0 && (
              <div className="question-section mb-4">
                <div className="section-header">
                  <h6 className="section-title">Section D: Other Questions</h6>
                  <span className="marks-info">
                    {getMarksLabel(otherList, 1)}
                  </span>
                </div>

                {otherList.map((q, qIdx) => (
                  <div key={getQuestionKey(q, qIdx)} className="question-card">
                    {renderQuestionHead(q)}
                    {renderOptions(q)}
                  </div>
                ))}
              </div>
            )}

            {/* EMPTY STATE: no questions for this assignment / selected set */}
            {shownCount === 0 && (
              <div className="text-center py-5 text-muted">
                <p>
                  {hasSets
                    ? `No questions in Set ${activeSet?.number}.`
                    : "No questions selected for this quiz."}
                </p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-2 bg-white">
          <button className="btn btn-secondary w-100 fw-bold" onClick={onHide}>
            Close Preview
          </button>
        </Modal.Footer>
      </Modal>

      <DeleteConfirmModal
        show={showConfirmModal}
        message="Are you sure you want to delete this question?"
        loading={loading}
        onCancel={closeDeleteConfirm}
        onConfirm={handleConfirmDelete}
      />

      <Loader show={loading} />

      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </>
  );
};

export default QuizPreviewModal;
